import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';

/**
 * Compatibility shim. Org + role now come from real session auth (AuthContext).
 * Kept so existing `useOrg()` call-sites keep working; new code should use
 * `useAuth()` / `usePermissions()` directly. To be removed once all callers move.
 */
const OrgContext = createContext(undefined);

const ROLES = ['owner', 'admin', 'developer'];

export function OrgProvider({ children }) {
  const { org, role, permissions, isOwner, isAdmin, isDeveloper } = useAuth();

  const value = useMemo(() => {
    const resolvedOrg = org || { id: 'acme-qa', name: 'Acme QA', slug: 'acme-qa', plan: 'Team' };
    return {
      orgs: [resolvedOrg],
      org: resolvedOrg,
      setCurrentOrg: () => {},
      role: role || 'developer',
      setRole: () => {}, // real role now — no preview switching
      roles: ROLES,
      isOwner,
      isAdmin,
      isDeveloper,
      canManage: !!(permissions.manageProjects || permissions.manageMembers),
    };
  }, [org, role, permissions, isOwner, isAdmin, isDeveloper]);

  return <OrgContext.Provider value={value}>{children}</OrgContext.Provider>;
}

export function useOrg() {
  const ctx = useContext(OrgContext);
  if (ctx === undefined) throw new Error('useOrg must be used within an OrgProvider');
  return ctx;
}
